import { Fragment, Suspense, useMemo, useRef, useState } from "react";
import GlobalLoader from "../../../components/Common/GlobalLoader";
import TableContainer from "../../../components/Common/TableContainer";
import { useTranslation } from "react-i18next";
import { Button, Col, Label } from "reactstrap";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import { useReactToPrint } from "react-to-print";


export default function MyWards() {
	const props = useTranslation();
	  const [periods, setPeriods] = useState(null);
	    const fp = useRef(null);
		   const printLayoutRef = useRef();
			const handlePrint = useReactToPrint({
			  content: () => printLayoutRef.current,
			});
	
	  const columns = useMemo(() => [
		{
		  header: props.t("no"),
		  style: "nbLines",
		  enableColumnFilter: false,
		  cell: (cellProps) => {
			return <span>{cellProps.row.index + 1}</span>;
		  },
		},
		{
		  header: props.t("products"),
		  style: "nbLines",
		  enableColumnFilter: false,
		  cell: (cellProps) => {
			return <span>{cellProps.row.index + 1}</span>;
		  },
		},
		{
		  header: props.t("qty_sold"),
		  style: "nbLines",
		  enableColumnFilter: false,
		  cell: (cellProps) => {
			return <span>{cellProps.row.index + 1}</span>;
		  },
		},
		{
		  header: props.t("unite_price"),
		  style: "nbLines",
		  enableColumnFilter: false,
		  cell: (cellProps) => {
			return <span>{cellProps.row.index + 1}</span>;
		  },
		},
		{
		  header: props.t("total_price"),
		  style: "nbLines",
		  enableColumnFilter: false,
		  cell: (cellProps) => {
			return <span>{cellProps.row.index + 1}</span>;
		  },
		},
	  ]);
	
  return (
	<Suspense fallback={<GlobalLoader />}>
		  <Fragment>
			<div className="heading align-middle p-4">
			  <div className="pb-2">
				<h4>{props.t("posted_sales")}</h4>
				 <div className="py-3 d-flex justify-content-between">
          <Col xl={2} sm={4} className="">
            <Label for="inputGroupSelect01"> {props.t("Pick_date")}: </Label>
            <Flatpickr
              className="flatpick-custom"
              id="inputGroupSelect01"
              ref={fp}
              placeholder={props.t("select_date_range")}
              defaultValue={periods}
              value={periods}
              options={{
                altInput: true,
                altFormat: "d / m/ Y",
                maxDate: new Date(),
              }}
              onChange={(e) => {
                console.log("dateData:", moment(e[0]).format("YYYY-MM-DD"));
                setPeriods(moment(e[0]).format("YYYY-MM-DD"));
              }}
            />
          </Col>
          <Button
            color="primary"
            style={{ marginLeft: "10px" }}
            onClick={() => handlePrint()}>
            <i className="fas fa-print"></i>
            {props.t("print_report")}
          </Button>
        </div>
			  </div>
			  <div>
				<TableContainer columns={columns} data={[]} />
			  </div>
			</div>
		  </Fragment>
		</Suspense>
  )
}
